export default __webpack_public_path__ + "static/media/dialogue-africa-nigeria-igbo-logo.e2311c41.png";